import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const TrashCan = createSvgIcon(
  <path d="M7.133 0h9.734l2.25 5.25H24V7.5h-3.098l-1.5 16.5H4.598l-1.5-16.5H0V5.25h4.883L7.133 0Zm.198 5.25h9.338l-1.286-3H8.617l-1.286 3ZM5.357 7.5l1.295 14.25h10.696L18.643 7.5H5.357Z" />,
  'TrashCan'
);

export { TrashCan };